'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('pageTitle', pageTitle);

    /** @ngInject */
    function pageTitle($window, $rootScope) {
        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/shared/page.title.html',
            scope: {
                title: '@'
            }
        };

        function link(scope, element, attrs) {

            var container = angular.element(element).closest('.container');

            angular.element(window).resize(function () {
                buidlTitle();
                scope.$apply();
            });

            buidlTitle();

            function buidlTitle() {
                var containerWidth = container.width();
                var dotsWidth = Math.floor(containerWidth / 2) - element.find('.title').width();
                var titleDots = Math.floor(dotsWidth / 15);
                scope.titleDots = [];
                for (var i = 0; i < titleDots - 1; i++) {
                    scope.titleDots.push(i);
                }
            }
        }
    }
})();